/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Workout_RestInputs */

const en_coach_workout_rest = /** @type {(inputs: Coach_Workout_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest Day`)
};

const de_coach_workout_rest = /** @type {(inputs: Coach_Workout_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhetag`)
};

/**
* | output |
* | --- |
* | "Rest Day" |
*
* @param {Coach_Workout_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_workout_rest = /** @type {((inputs?: Coach_Workout_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Workout_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_workout_rest(inputs)
	return de_coach_workout_rest(inputs)
});